// src/screens/Admin/navigation screens/support/TicketBadges.jsx
import React from "react";

export const StatusBadge = ({ code, className = "" }) => {
  const map = {
    O: { text: "Open", bg: "#fff4e5", border: "#ffe0b2", color: "#b26a00" },
    P: { text: "In Progress", bg: "#e3f2fd", border: "#bbdefb", color: "#1565c0" },
    C: { text: "Closed", bg: "#e6f4ea", border: "#c8e6c9", color: "#2e7d32" },
  };
  const s = map[code] || map.O;
  return (
    <span
      className={`admin-ticket-badge ${className}`}
      style={{
        background: s.bg,
        border: `1px solid ${s.border}`,
        color: s.color,
      }}
    >
      {s.text}
    </span>
  );
};

export const PriorityBadge = ({ value }) => {
  const v = String(value || "").toLowerCase();
  const map = {
    low: { bg: "#eef7ff", border: "#cfe8ff", color: "#1b74e4", text: "Low" },
    medium: { bg: "#fff5e6", border: "#ffe1b3", color: "#b25c00", text: "Medium" },
    high: { bg: "#ffebee", border: "#ffcdd2", color: "#c62828", text: "High" },
    urgent: { bg: "#fbe9e7", border: "#ffccbc", color: "#d84315", text: "Urgent" },
  };
  const s = map[v] || map.medium;
  return (
    <span
      className="admin-ticket-badge"
      style={{
        background: s.bg,
        border: `1px solid ${s.border}`,
        color: s.color,
      }}
    >
      {s.text}
    </span>
  );
};
